import React, { SyntheticEvent } from 'react';
import { FileDataModal } from '../types';
import UpsertModal from '../../../../components/General/UpsertModal';

function UpsertFileModal(
  {
    modalAddEdit,
    setModalAddEdit,
    handleCloseModal,
    modalValues,
    handleFieldChange,
    itemsUI,
    addFunction,
  }: {
    modalAddEdit: { id: string, open: boolean },
    setModalAddEdit: React.Dispatch<React.SetStateAction<{
      id: string;
      open: boolean;
    }>>,
    handleCloseModal: (setFunction: React.Dispatch<React.SetStateAction<{
      id: string;
      open: boolean;
    }>>) => void,
    modalValues: FileDataModal,
    setModalValues: React.Dispatch<React.SetStateAction<FileDataModal>>,
    handleFieldChange: (
      e: React.ChangeEvent<HTMLInputElement> | SyntheticEvent<Element, Event> | Date | File,
      source: string) => void,
    itemsUI: {
      label: string;
      key: string;
      showOnTable: boolean;
      showOnModal: boolean;
      typeField: string;
      selectFields?: object[];
      valueType: string;
    }[],
    addFunction: () => void,
  },
) {
  return (
    <UpsertModal<FileDataModal>
      title={'archivo'}
      modalAddEdit={modalAddEdit}
      setModalAddEdit={setModalAddEdit}
      handleCloseModal={handleCloseModal}
      modalValues={modalValues}
      handleFieldChange={handleFieldChange}
      itemsUI={itemsUI}
      handleAddFunction={addFunction}
      handleEditFunction={() => { }}
    />
  );
}

export default UpsertFileModal;
